<template>
  <div>
    <bd-table-list
      idTable="mandat_ID"
      :breadcrumb="breadcrumb"
      ref="resource"
      title="Mandats"
      subtitle="Recherche de mandats"
      autocomplete_idHistory="warrants"
      autocomplete_field="debiteur.nom_soc || mandat.ID"
      bdTable="warehouse_mandat"
      :directLoad="true"
      :actions="actions"
      :fields="fields"
      :Api="Api"
    >
      <template #menu>
        <b-button
          v-if="nextUnusedWarrant"
          variant="success"
          size="sm"
          :to="{ name: 'warrantOpen', params: { id: nextUnusedWarrant } }"
          ><span style="color: #fff"
            >Ouvrir un mandat (Reste {{ totalUnusedWarrants }})</span
          ></b-button
        >
        <b-button @click="orderNewWarrants()" size="sm" class="ml-3"
          >Commander de nouveaux mandats</b-button
        >
      </template>
      <template v-slot:cell(mandat_ID)="data">
        <b-link
          :to="{ name: 'warrantView', params: { id: data.item.mandat_ID } }"
        >
          {{ data.item.mandat_ID }}
        </b-link>
      </template>
      <template v-slot:cell(debiteur)="data">
        <b-link
          :to="{ name: 'debtorView', params: { id: data.item.debiteurID } }"
        >
          {{ getDebiteur(data.item) }}
        </b-link>
      </template>
    
    </bd-table-list>
    <b-modal id="orderWarrants" hide-footer>
      <template #modal-title> Commander de nouveaux mandats </template>
      <b-form-group label="Choisissez une option">
        <b-form-radio-group
          id="radio-group-2"
          stacked
          v-model="selected_order"
          name="radio-sub-component"
        >
          <b-form-radio value="10">10 mandats pour 350 €</b-form-radio>
          <b-form-radio value="20">20 mandats pour 600 €</b-form-radio>
          <b-form-radio value="30"
            >30 mandats pour {{ 30 * 25 }} €</b-form-radio
          >
          <b-form-radio value="50"
            >50 mandats pour {{ 50 * 20 }} €</b-form-radio
          >
          <b-form-radio value="100"
            >100 mandats pour {{ 100 * 15 }} €</b-form-radio
          >
        </b-form-radio-group>
      </b-form-group>
      <b-button @click="$bvModal.hide('orderWarrants')">Annuler</b-button>
      <b-button @click="order()" variant="success" class="ml-3"
        >Commander {{ selected_order }} mandats</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import BdTableList from "@/components/BdTableList";
import creditors from "@/services/creditors.js";
import String from "@/services/String.js";
import DateTime from "@/services/DateTime.js";
import warrants from "@/services/warrants.js";
export default {
  name: "Warrants",
  components: {
    BdTableList,
  },
  data() {
    return {
      warnings: [],
      Api: warrants,
      nextUnusedWarrant: false,
      totalUnusedWarrants: 0,
      selected_order: 10,
      breadcrumb: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Mandats",
          active: true,
        },
      ],
      actions: [
        {
          label: "Visualiser",
          to: "warrantEdit",
          icon: "pencil-square",
          variant: "success",
        },
      ],
      fields: [
        {
          key: "mandat_ID",
          label: "#",
          sortable: true,
          class: "text-center",
          thStyle: { width: "100px" },
        },
        {
          key:"ref_creancier",
          label: "Votre référence",
          class: "text-left",
          thStyle: { width: "150px" },
        },
        {
          key: "mandat_status",
          label: "Statut",
          sortable: true,
          thStyle: { width: "100px" },
        },
        {
          key: "mandat_solde",
          label: "Solde",
          sortable: true,
          class: "text-right",
          formatter: (value) => parseInt(value).toFixed(2) + " €",
          thStyle: { width: "5%" },
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
          class: "text-truncate",
          formatter: (value, key, item) => {
            let a = "";
            if (item.debiteur_nom_soc) {
              a += item.debiteur_nom_soc;
            }
            if (item.debiteur_nom && item.debiteur_nom_soc) {
              a += " (" + item.debiteur_prenom + " " + item.debiteur_nom + ")";
            } else if (!item.debiteur_nom_soc) {
              a += item.debiteur_prenom + " " + item.debiteur_nom;
            }
            return a;
          },
        },
        {
          key: "adresse",
          label: "Adresse",
          sortable: true,
          class: "text-truncate",

          formatter: (value, key, item) => {
            let a =
              item.debiteur_rue1 +
              ", " +
              item.debiteur_codepostal +
              " " +
              item.debiteur_localite;
            if (item.debiteur_pays) {
              a += " (" + item.debiteur_pays + ")";
            }

            return a;
          },
        },

        
        {
          key: "actions",
          label: "Actions",
          class: "text-center",
          sortable: false,
          thStyle: { width: "100px" },
        },
      ],
    };
  },
  created() {
    creditors.nextUnusedWarrant().then((response) => {
      if (response.data.id) {
        this.nextUnusedWarrant = response.data.id;
        this.totalUnusedWarrants = response.data.total;
      }
    });
  },
  methods: {
    order() {
      creditors.orderWarrants(this.selected_order).then((response) => {
        if (response.data.success) {
          this.$bvToast.toast(
            "Merci pour votre commande. Elle sera traitée dans les plus brefs délais.",
            {
              title: `Recuperator`,
              toaster: "b-toaster-top-center",
              variant: "success",
              autoHideDelay: 10000,
              solid: false,
            }
          );
          this.$bvModal.hide('orderWarrants')
        }
      });
    },
    orderNewWarrants() {
      this.$bvModal.show("orderWarrants");
    },
    getDebiteur(item) {
      let a = "";
      if (item.debiteur_nom_soc) {
        a += item.debiteur_nom_soc;
      }
      if (item.debiteur_nom && item.debiteur_nom_soc) {
        a += " (" + item.debiteur_prenom + " " + item.debiteur_nom + ")";
      } else if (!item.debiteur_nom_soc) {
        a += item.debiteur_prenom + " " + item.debiteur_nom;
      }
      return a;
    },

    company(str) {
      return String.company(str);
    },
    toDate(d) {
      return DateTime.humanDate(d);
    },
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>